<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.5 12.25V5.75H8.25V8.40385C8.25 8.95613 8.69772 9.40385 9.25 9.40385H14.5V12.25H3.5ZM16.5 8.40385V13.25C16.5 13.8023 16.0523 14.25 15.5 14.25H2.5C1.94772 14.25 1.5 13.8023 1.5 13.25V4.75C1.5 4.19772 1.94772 3.75 2.5 3.75H9.25H15.5C16.0523 3.75 16.5 4.19772 16.5 4.75V8.40385Z" :fill="color"/>
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: '16',
    },
    color: {
      type: String,
      default: '#007893',
    },
  },
};
</script>
